
/**
 * Setup sharing buttons (Facebook, Twitter, & Email)
 */
!function(gc)
{
	'use strict';

	// Expose on global gc object
	gc.setupShareButtons = setupShareButtons;
	gc.shareButtonsPopupHandler = shareButtonsPopupHandler;

	var url = canonicalUrl(),
		facebookUrl = false,
		twitterUrl = false,
		emailUrl = false,
		twitterUrlShortened = false,
		twitterButtons = [];

	function setupShareButtons(id)
	{
		var buttons = document.getElementById(id).children;
		var classPrefix = 'share__button--';
		for (var i = 0; i < buttons.length; i++) {

			var button = buttons[i];

			// Skip buttons that already have links
			if ( button.href === '#' ) { continue; }

			// Add classes to other buttons
			var classes = button.classList;
			if ( classes.contains(classPrefix + 'facebook') ) {
				setupFacebook( button );
			}
			else if ( classes.contains(classPrefix + 'twitter') ) {
				setupTwitter( button );
			}
			else if ( classes.contains(classPrefix + 'email') ) {
				setupEmail( button );
			}
			else {
				console.error('Unrecognized social button', buttons[i]);
			}
		}
	}

	function canonicalUrl()
	{
		// First attempt to get Wordpress canonical url (set by Yoast SEO)
		try {
			url = document.querySelector('[property="og:url"]').content;
		}
		// Fallback to current url w/out query params or hashes
		catch (err) {}
		url = url || window.location.href;

		// Remove any existing params & hashes
		url = url.split('?')[0].split('#')[0];

		return url;
	}

	function setupFacebook(button)
	{
		if ( !facebookUrl ) {
			// Facebook will load the current page and get all the information from meta tags
			facebookUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent( url + '?utm_source=facebook&utm_medium=social&utm_campaign=sharebuttons' );
		}
		setupButton(button, facebookUrl, true);
	}

	function setupTwitter(button)
	{
		// Keep a list of buttons. This way, once a shortened url with parameters is fetched from Google Url Shortener,
		// all prior buttons (using regular page url) will be updated
		twitterButtons.push(button);

		if ( !twitterUrl ) {
			// Twitter must be given the page title and url
			var twUrl = 'https://twitter.com/intent/tweet?via=GoshenCollege&text=',
				twTitleMetaTag = document.querySelector('meta[name="twitter:title"]'),
				twTitle;

			// Attempt to get page title from twitter:title meta tag (output by Yoast SEO)
			if ( twTitleMetaTag && twTitleMetaTag.content ) {
				twTitle = twTitleMetaTag.content;
			}
			// Fallback to document title
			else {
				twTitle = document.title;
			}
			twTitle = twTitle.replace('| Goshen College', '').replace('| GC', '');

			twUrl += encodeURIComponent( twTitle );

			// Now append current page's url (w/out tracking)
			twitterUrl = twUrl + '&url=' + encodeURIComponent( url );

			// But if possible, use a shortened tagged url using the Google Url shortener
			if ( !twitterUrlShortened ) {
				twitterUrlShortened = true;
				gc.scripts.jquery.then(function()
				{
					var taggedUrl = url + '?utm_source=twitter&utm_medium=social&utm_campaign=sharebuttons'
					$.ajax({
						url: 'https://www.googleapis.com/urlshortener/v1/url?key=AIzaSyD1cJCv4XR9apwjjRWC71NoY72YRoGTpAE',
						type: "POST",
						data: JSON.stringify({ longUrl: taggedUrl }),
						contentType:"application/json; charset=utf-8",
						cache: true,
						success: function(resp)
						{
							if ( resp.id ) {
								twitterUrl = twUrl + '&url=' + encodeURIComponent( resp.id );
								// Replace all Twitter buttons with non-tracking urls with this one
								for (var i = 0; i < twitterButtons.length; i++) {
									twitterButtons[i].href = twitterUrl;
								}
							}
							else {
								console.error('Unexpected response from Google Url Shortener API', resp);
							}
						}
					});
				});
			}
		}
		setupButton(button, twitterUrl, true);
	}

	function setupEmail(button)
	{
		if ( !emailUrl ) {

			var lineBreak = '%0D%0A',
				emUrl = 'mailto:?body=' + lineBreak + lineBreak,
				emTitleMetaTag = document.querySelector('meta[property="og:title"]'),
				emTitle;

			// Attempt to get page title from og:title meta tag (output by Yoast SEO)
			if ( emTitleMetaTag && emTitleMetaTag.content ) {
				emTitle = emTitleMetaTag.content;
			}
			// Fallback to document title
			else {
				emTitle = document.title;
			}
			emTitle = emTitle.replace('| Goshen College', '').replace('| GC', '');

			emailUrl = emUrl + encodeURIComponent( emTitle ) + lineBreak + encodeURIComponent( url + '?utm_source=friends&utm_medium=email&utm_campaign=sharebuttons' )
		}
		setupButton(button, emailUrl, false);
	}

	// Add href to button that opens in new tab/window.
	// If it's a popup, attempt to open a small window
	function setupButton(button, href, isPopup)
	{
		button.href = href;
		button.target = '_blank';

		if ( isPopup ) {
			gc.scripts.jquery.then(function()
			{
				$(button).click( shareButtonsPopupHandler );
			});
		}
	}

	/**
	 * On button click, display popup instead of new tab
	 * @source: http://www.sitepoint.com/social-media-button-links/
	 */
	function shareButtonsPopupHandler( event )
	{
		var width = 600,
			height = 400,
			button = this; // reference to <a> tag provided by jQuery

		// popup position
		var
			px = Math.floor(((screen.availWidth || 1024) - width) / 2),
			py = Math.floor(((screen.availHeight || 700) - height) / 2);

		// open popup
		var popup = window.open(button.href, "social",
			"width="+width+",height="+height+
			",left="+px+",top="+py+
			",location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1");

		if (popup) {
			popup.focus();
			if (event.preventDefault) event.preventDefault();
			event.returnValue = false;
		}

		return !!popup;
	}

}(window.gc);
